import '@/api/dms/setup'; // Side-effect: configures Hey API DMS client with shared axios instance
import { FolderOpen, Shield } from 'lucide-react';
import { createDmsNavItems } from '@/config/nav';
import { useCalibrationAlertCount } from '@/features/dms/calibration/hooks/useCalibrationAlertCount';
import { useOpenCapaCount } from '@/features/dms/capas/hooks/useOpenCapaCount';
import { createDmsCommandProviders } from '@/features/dms/command-providers';
import { useOpenEcrCount } from '@/features/dms/ecrs/hooks/useOpenEcrCount';
import { usePdfStatusCount } from '@/features/dms/hooks/usePdfStatusCount';
import { useDmsPermissionResources } from '@/features/dms/hooks/usePermissionResources';
import { useReviewCount } from '@/features/dms/hooks/useReviewCount';
import { getDmsRoutes } from '@/routes/dms';
import type { AppConfig } from './types';

export const dmsConfig: AppConfig = {
  id: 'dms',
  name: 'Pill Connect DMS',
  shortName: 'Pill Connect',
  logoAriaLabel: 'Pill Connect logo',
  sentry: { project: 'atlas-dms-frontend' },
  searchEnabled: true,
  searchPlaceholder: 'Search documents...',
  navItems: createDmsNavItems({
    reviewCount: { useCount: useReviewCount, variant: 'primary' },
    pdfStatusCount: { useCount: usePdfStatusCount, variant: 'warning' },
    openCapaCount: { useCount: useOpenCapaCount, variant: 'primary' },
    openEcrCount: { useCount: useOpenEcrCount, variant: 'primary' },
    calibrationAlertCount: { useCount: useCalibrationAlertCount, variant: 'primary' },
  }),
  getRoutes: getDmsRoutes,
  permissionSections: [
    {
      resourceType: 'feature',
      label: 'Features',
      icon: Shield,
    },
    {
      resourceType: 'folder',
      label: 'Folders',
      icon: FolderOpen,
      children: [{ resourceType: 'folder', label: 'Sub-folders', icon: FolderOpen }],
    },
  ],
  usePermissionResources: useDmsPermissionResources,
  commandProviders: createDmsCommandProviders,
};
